var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIconYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pdf_icon_yellow_svg__clip0_23575_5487)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pdf_icon_yellow_svg__clip1_23575_5487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8c0-1.68 0-2.52.33-3.16.29-.56.75-1.02 1.31-1.31C2.28 0 3.12 0 4.8 0h3.21c.73 0 1.1 0 1.45.08.31.07.6.19.87.36.3.19.56.44 1.08.96l3.19 3.19c.52.52.78.78.96 1.08.16.27.29.56.36.87.08.35.08.71.08 1.45v7.21c0 1.68 0 2.52-.33 3.16-.29.56-.75 1.02-1.31 1.31-.64.33-1.48.33-3.16.33H4.8c-1.68 0-2.52 0-3.16-.33-.56-.29-1.02-.75-1.31-1.31C0 17.72 0 16.88 0 15.2V4.8z",
    fill: "#F6AA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.56 5.68c-.19-.3-.44-.56-.96-1.08l-3.19-3.19c-.52-.52-.78-.78-1.08-.96-.1-.06-.21-.12-.32-.17V5c0 .56.45 1 1.01 1l4.69-.04c-.04-.09-.09-.19-.14-.28h-.01z",
    fill: "#E74"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8c0-1.68 0-2.52.33-3.16.29-.56.75-1.02 1.31-1.31C2.28 0 3.12 0 4.8 0h3.21c.73 0 1.1 0 1.45.08.31.07.6.19.87.36.3.19.56.44 1.08.96l3.19 3.19c.52.52.78.78.96 1.08.16.27.29.56.36.87.08.35.08.71.08 1.45v7.21c0 1.68 0 2.52-.33 3.16-.29.56-.75 1.02-1.31 1.31-.64.33-1.48.33-3.16.33H4.8c-1.68 0-2.52 0-3.16-.33-.56-.29-1.02-.75-1.31-1.31C0 17.72 0 16.88 0 15.2V4.8z",
    fill: "#F6AA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15.5h-6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75zm2-4h-8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.56 5.68c-.19-.3-.44-.56-.96-1.08l-3.19-3.19c-.52-.52-.78-.78-1.08-.96-.1-.06-.21-.12-.32-.17V5c0 .56.45 1 1.01 1l4.69-.04c-.04-.09-.09-.19-.14-.28h-.01z",
    fill: "#E74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pdf_icon_yellow_svg__clip0_23575_5487"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pdf_icon_yellow_svg__clip1_23575_5487"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v20H0z"
  })))));
}
export default SvgPdfIconYellow;